module.exports = {"TXTCLI_Current_Balance":{"id":"TXTCLI_Current_Balance","defaultMessage":"Τρέχον Υπόλοιπο","flags":["TRACK"],"track":"Current Balance"}}